var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6459 26.8967L11.0473 26.8967C11.5996 21.9161 14.1136 17.8827 17.8947 15.5761L17.8947 15.4861H0.191528L0.191529 12.2124L17.8972 12.2099V12.1199C14.1161 9.81331 11.6021 5.77987 11.0498 0.799302H14.6484C15.3157 6.53958 19.1442 11.5176 26.2914 12.4423L26.2914 15.2562C19.1467 16.1783 15.3157 21.1589 14.6484 26.8992L14.6459 26.8967Z",
    fill: "#BF1646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowContact);
export default __webpack_public_path__ + "static/media/arrowContact.397184a71654c22a8d931aff71566ad0.svg";
export { ForwardRef as ReactComponent };